import React from 'react';
import { Grid, GridProps } from '@mui/material';

export const Col = React.forwardRef<HTMLDivElement, GridProps>((props, ref) => {
  return <Grid ref={ref} item {...props} />;
});

Col.displayName = 'Col';
